export default __webpack_public_path__ + "static/media/Metal_Wind_Chimes_at_Sunset.0b928039.mp4";